// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';

import { HtmlContentLoader } from '@powdr/components';
import { cleanSilverpopFormCode } from '@powdr/utils';

import { StyledFormSilverpop } from './styles';

export const FormSilverpop = ({
  formCode,
  parentColorProfile = null,
}) => {
  const formRef = useRef(null);

  const formatForm = () => {
    const form = formRef.current;
    if (!form) return;

    const email = localStorage.getItem('email') || '';
    form.querySelectorAll('input,div,td,select').forEach((i) => { i.removeAttribute('style'); });
    form.querySelectorAll('select,.textInput,input[type="text"],textarea').forEach((i) => { i.classList.add('form-control'); });

    form.querySelectorAll('input[type="submit"],button[type="submit"],._submit').forEach((i) => { i.classList.add('form-button'); });
    form.querySelectorAll('.checkbox,._checkbox-radio').forEach((i) => {
      i.classList.remove('checkbox');
      i.classList.add('checkbox-alt');
    });
    form.querySelectorAll('.required,.field-required').forEach((i) => {
      i.parentElement?.parentElement?.parentElement?.querySelectorAll('input').forEach((j) => { j.setAttribute('required', ''); });
    });
    const emailInput = Array.from(form.querySelectorAll('input')).find((input) => ['email', 'Email', 'EMAIL'].some((i) => input.outerHTML.includes(i)));
    if (emailInput) emailInput.value = email;
  };

  useEffect(() => {
    formatForm();
  }, [formCode]);

  return (
    <StyledFormSilverpop colorProfile={parentColorProfile}>
      <div ref={formRef}>
        <HtmlContentLoader
          html={cleanSilverpopFormCode(formCode?.value)}
          allowRerender
        />
      </div>
    </StyledFormSilverpop>
  );
};

FormSilverpop.propTypes = {
  formCode: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
  parentColorProfile: PropTypes.number,
};
